import type { FacetHighlight } from '@/types/search'
import { cn } from '@/lib/utils'
import { EvidenceStateDot, EVIDENCE_STATE_META } from '@/components/Shared/EvidenceStateBadge'

interface FacetHighlightChipProps {
  highlight: FacetHighlight
  className?: string
}

export function FacetHighlightChip({ highlight, className }: FacetHighlightChipProps) {
  return (
    <span
      className={cn('inline-flex items-center gap-[6px]', className)}
      title={highlight.evidenceState}
    >
      <EvidenceStateDot state={highlight.evidenceState} />
      <span
        className={cn(
          'font-mono text-[10px] uppercase tracking-[0.06em]',
          EVIDENCE_STATE_META[highlight.evidenceState].textClassName,
        )}
      >
        {highlight.facetType}
      </span>
    </span>
  )
}
